<template>
    <div class="steps__body__step steps__body__step--three">
        <template v-if="!hasPositions">
            <div class="step-headline">Sie möchten ihr Produkt personalisieren?</div>
            <p>
                Sie haben sich entschieden, das Produkt mit einem vollflächigen Dekor zu Veredeln.
                Dadurch können keine Personalisierungen vorgenommen werden.<br>
                Wenn Sie Ihrem Produkt einen persönlicheren Touch verleihen möchten,
                wechseln Sie in den vorherigen Schritt und wählen Sie entweder die Designsoption "Mit Filet
                gestalten" oder "Ohne Design".
            </p>
        </template>
        <template v-if="hasPositions">
            <div class="step-headline">Position auf dem Produkt wählen</div>
            <p>
                Mittig, seitlich oder am Rand? Auf jeder der drei angebotenen Positionen können Sie entweder Ihr Logo,
                eines unserer Icons oder Ihren eigenen Text anbringen. Wählen Sie dazu zunächst eine Position aus und
                entscheiden Sie sich anschließend für die gewünschte Personalisierung (<strong>nur ein Element je Position</strong>).
            </p>

            <ul class="positions">
                <template v-for="position of positions">
                    <li class="position-tab"
                        :class="{'active': isCurrentPosition(position)}"
                        :key="position.getRoot().getId()"
                        @click="positionTabClickHandler(position)"
                        v-if="position.getRoot().isVisible()"
                    >
                        <img :src="position.getRoot().getThumbnailUrl()" :alt="position.getRoot().getName()">
                    </li>
                </template>
            </ul>

            <position-customization v-for="position of positions"
                                    :position="position"
                                    :key="position.getRoot().getId()"
                                    v-show="isCurrentPosition(position)"
            ></position-customization>
        </template>

        <div class="step__controls">
            <button type="button" class="button button--blue button--outline prev-step"
                    @click="prevButtonClickHandler">
                <span>vorheriger Schritt</span>
            </button>

            <button type="button" class="button button--blue button--fill next-step" @click="cartButtonClickHandler"
                    id="mytw_add_to_cart_step3">
                <span>in den Warenkorb</span>
            </button>
        </div>
    </div>
</template>

<script>
    import {mapMutations, mapGetters}  from "vuex"
    import PositionCustomization       from "./PositionCustomization"
    import PositionCustomizationModule from "../../store/PositionCustomization"

    export default {
        name:       "Customization",
        components: {PositionCustomization},
        computed:   {
            ...mapGetters('customizationConfiguration', ['hasCurrentPosition']),

            /**
             * Returns all available customizationType positiions
             */
            positions: function () {
                let positions = this.$store.state.customizationPositions.filter(
                    position => position.getRoot().isVisible()
                );

                return positions;
            },

            hasPositions: function () {
                return this.positions.length > 0
            },

            /**
             * Returns the currently selected position
             */
            currentPosition: function () {
                return this.hasCurrentPosition ? this.$store.state.customizationConfiguration.currentPosition : null
            }
        },
        created() {
            this.prepareComponent();
        },
        beforeUpdate() {
            // Register the position modules in case new positions are available
            this.registerPositionStoreModules();
        },
        methods:    {

            prepareComponent: function(){
                this.registerPositionStoreModules()
                let activePositions = this.positions.filter(
                    position => position.getRoot().isVisible()
                );
                this.updateCurrentPosition(activePositions[0])
                this.applyCurrentPosition()
            },

            ...mapMutations('customizationConfiguration', ['updateCurrentPosition']),

            isCurrentPosition: function (position) {
                if (this.hasCurrentPosition) {
                    return this.currentPosition.getRoot().getId() === position.getRoot().getId()
                }

                return position
            },

            positionTabClickHandler: function (position) {
                this.updateCurrentPosition(position)
                this.applyCurrentPosition()
            },

            /**
             * Dynamically register the store modules for every position
             */
            registerPositionStoreModules: function () {
                this.positions.forEach(position => {
                    let positionSlug = position.getRoot().getSlug()
                    if (!this.$store.state[positionSlug]) {
                        this.$store.registerModule(positionSlug, PositionCustomizationModule)
                    }
                })

                return this
            },

            /**
             * Apply the current position to expivi
             */
            applyCurrentPosition() {
                return this.$expiviReady.then(expivi => {
                    let stateAttribute = this.currentPosition.filterByType('mytw_conf_position_state');

                    if (stateAttribute !== null) {
                        let values = stateAttribute.getAttributeValues()
                        expivi.setProductAttribute(stateAttribute.getId(), values[1].getId())
                    }
                })
            },

            /**
             * Go back to step 1 - product selection.
             * TODO: Check, if we have to reset everything
             */
            prevButtonClickHandler: function () {
                this.$router.go(-1)
            },

            cartButtonClickHandler: function () {
                this.addDataLayer({
                    'event': 'mytw_add_to_cart_step3'
                })

                this.$emit('clicked:cart')
            }
        }
    }
</script>

<style scoped>

</style>
